var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('img',{attrs:{"src":`${_vm.publicPath}img/external-link.svg`,"alt":"goes to external website"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }